export const getCookieValue = name => {
  const cookies = document.cookie.split(";")
  const cookie = cookies.find(c => c.trim().startsWith(`${name}=`))
  return cookie ? cookie.split("=")[1] : null
}
